"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GreaterOrEqual = exports.Greater = exports.LessOrEqual = exports.Less = void 0;
var expression_1 = require("./expression");
var datatypes_1 = require("../datatypes/datatypes");
// Equal is completely handled by overloaded#Equal
// NotEqual is completely handled by overloaded#Equal
var Less = /** @class */ (function (_super) {
    __extends(Less, _super);
    function Less(json) {
        return _super.call(this, json) || this;
    }
    Less.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx).map(function (x) { return datatypes_1.Uncertainty.from(x); });
        if (args[0] == null || args[1] == null) {
            return null;
        }
        return args[0].lessThan(args[1]);
    };
    return Less;
}(expression_1.Expression));
exports.Less = Less;
var LessOrEqual = /** @class */ (function (_super) {
    __extends(LessOrEqual, _super);
    function LessOrEqual(json) {
        return _super.call(this, json) || this;
    }
    LessOrEqual.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx).map(function (x) { return datatypes_1.Uncertainty.from(x); });
        if (args[0] == null || args[1] == null) {
            return null;
        }
        return args[0].lessThanOrEquals(args[1]);
    };
    return LessOrEqual;
}(expression_1.Expression));
exports.LessOrEqual = LessOrEqual;
var Greater = /** @class */ (function (_super) {
    __extends(Greater, _super);
    function Greater(json) {
        return _super.call(this, json) || this;
    }
    Greater.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx).map(function (x) { return datatypes_1.Uncertainty.from(x); });
        if (args[0] == null || args[1] == null) {
            return null;
        }
        return args[0].greaterThan(args[1]);
    };
    return Greater;
}(expression_1.Expression));
exports.Greater = Greater;
var GreaterOrEqual = /** @class */ (function (_super) {
    __extends(GreaterOrEqual, _super);
    function GreaterOrEqual(json) {
        return _super.call(this, json) || this;
    }
    GreaterOrEqual.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx).map(function (x) { return datatypes_1.Uncertainty.from(x); });
        if (args[0] == null || args[1] == null) {
            return null;
        }
        return args[0].greaterThanOrEquals(args[1]);
    };
    return GreaterOrEqual;
}(expression_1.Expression));
exports.GreaterOrEqual = GreaterOrEqual;
//# sourceMappingURL=comparison.js.map